<template>
  <div data-grm-comp="RoomCallConnectionState" class="conn-stats">
    <div class="conn-summary">
      <span>total[{{summary.totalCnt}}]</span>
      <span>up[{{summary.sendCnt}}/{{summary.send}}/{{summary.sendAvg}}]</span>
      <span>down[{{summary.receiveCnt}}/{{summary.receive}}/{{summary.receiveAvg}}]</span>
    </div>
    <div v-if="windowMode">
      <input type="text" v-model="filterText" style="width: 300px; height: 20px;">
      <button style="width: 20px; height: 20px;" @click="filterText=''">X</button>
    </div>
    <div class="conn-stats-user"
        v-for="(r) in filterUsers"
        :key="r.userId"
    >
      <p>
        <span><b>[{{r.nickname}}]</b></span>
        <span v-if="!!r.device">{{r.device}}</span>
        <span v-if="!!r.version">, {{r.version}}</span>
      </p>
      <p>
        <span>ConnTime: {{r.connTime}}</span>
        <span>, Codecs: {{Array.from(r.codecs).join(',')}}</span>
      </p>
      <p>
        {{r.connectionType.transport}},
        L:<span v-html="parseCandidateType(r.connectionType.local.candidateType)"></span>{{
          '('
          + (r.connectionType.local.networkType && r.connectionType.local.networkType !== 'unknown' ? (r.connectionType.local.networkType + ', ') : '')
          + r.connectionType.local.ipAddress +':'+ r.connectionType.local.port
          + ')'
        }},
        R:<span v-html="parseCandidateType(r.connectionType.remote.candidateType)"></span>{{
          '('
          + (r.networkType && r.networkType !== 'unknown' ? (r.networkType + ', ') : '')
          + r.connectionType.remote.ipAddress +':'+ r.connectionType.remote.port
          + ')'
        }}
      </p>
      <p>
        Data: {{r.totalPacket}}, S:{{r.packetSent}} ({{r.videoBytesSent}}/{{r.audioBytesSent}}), R:{{r.packetReceived}} ({{r.videoBytesReceived}}/{{r.audioBytesReceived}})
      </p>
      <p v-html="r.videoSizeInfo"></p>
<!--      <p v-html="r.videoFrameInfo"></p>-->
<!--      <p>PacketLost: S:{{r.sendPacketLostInfo}}</p>-->
<!--      <p>PacketLost: R:{{r.receivePacketLostInfo}}</p>-->
<!--      <p>JitterBufferMs: <span v-html="r.jitterBufferInfo"></span></p>-->
<!--      <p>BandwidthSet: {{r.bandwidthSetInfo}}</p>-->
      <p>BW: {{r.bandwidthInfo}}</p>
<!--      <p>Rtt: <span v-html="r.rttInfo"></span></p>-->
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import {mapActions} from "vuex";

export default {
  name: 'RoomCallConnectionState',
  data() {
    return {
      windowMode: false,
      filterText: '',
      users: {},
      summary: {
        send: 0,
        receive: 0,
        sendCnt: 0,
        receiveCnt: 0,
        totalCnt: 0,
        sendAvg: 0,
        receiveAvg: 0,
      }
    }
  },
  computed: {
    filterUsers () {
      let {filterText, users} = this;
      if(!filterText){
        return users;
      }
      filterText = filterText.trim();
      let result = {};
      for(let userId in users){
        const user = users[userId];
        if(
            user.nickname.includes(filterText)
            || user.userId.includes(filterText)
        ){
          result[userId] = user;
        }
      }
      return result;
    },
  },
  created() {
    this.windowMode = this.$store.state.call.showConnectionStatsWindow;

    console.log('conn state created : win[%s]', this.windowMode);
    this._events = _Events();
    this.$roomApi.addEventListeners(this._events, this);
  },
  mounted() {
    if(this.windowMode){
      this.window = window.open('', '_grm_conn_state_', 'width=500px,height=300px');

      this.getDocument().querySelectorAll('style').forEach(s => {
        let dataName = this.$el.getAttributeNames().find(attr => attr.startsWith('data-v-'));
        if(!s.innerText.includes(dataName)){
          return;
        }

        let clone = s.cloneNode(true);
        clone.href = this.href;
        this.window.document.head.appendChild(clone);
      });

      this.windowCloseEvent = this.close.bind(this);
      this.window.addEventListener('beforeunload', this.windowCloseEvent);
      this.getDefaultView().addEventListener('beforeunload', this.windowCloseEvent, {once: true});

      this.window.document.body.classList.add('new-window');
      this.window.document.title = '[grm-connState] - ' + this.$roomApi?.getRoomData()?.room?.roomTitle;

      // 맨 마지막
      this.oriParent = this.$el.parentElement;
      this.window.document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    console.log('conn state destroyed');
    this.$roomApi.removeEventListeners(this._events);

    this.close();
  },
  methods: {
    ...mapActions('call', ['hideConnectionStats']),
    close() {
      if(!this.window) return;

      this.oriParent && this.oriParent.appendChild(this.$el);

      this.window.close();
      this.window = null;
      this.getDefaultView().removeEventListener('beforeunload', this.windowCloseEvent);
      this.hideConnectionStats();
    },
    parseCandidateType(t) {
      switch(t){
        case 'local':
        case 'host':
        case 'srflx':
        case 'stun':
          return t;
        default:
          break;
      }
      return '<span class="warn" style="color:red;font-weight:bold;">'+t+'</span>';
    },
    fixedN(n, unit) {
      if(!n){
        return '-';
      }
      unit = unit !== false;

      n = n/1024;
      if(n >= 1024){
        return (n/1024).toFixed(1) + (unit?'MB':'');
      }
      return n.toFixed(1) + (unit?'KB':'');
    },
    setSummary () {
      const sum = {
        send:0, receive:0,
        sendCnt:0, receiveCnt:0,
        totalCnt: 0
      };
      for(let userId in this.users){
        const result = this.users[userId];
        sum.totalCnt++;
        ['audio', 'video'].forEach(kind => {
          let data = result[kind];
          if(!data) return;
          ['send', 'receive'].forEach(type => {
            let bps = data[type].availableBandwidthKbps || 0;
            if(bps > 0){
              sum[type+'Cnt']++;
              sum[type] += data[type].availableBandwidthKbps || 0;
            }
          });
        });
      }

      Object.assign(this.summary, sum, {
        send: sum.send.toFixed(1),
        receive: sum.receive.toFixed(1),
      });
      try{
        Object.assign(this.summary, {
          sendAvg: (sum.send/sum.sendCnt).toFixed(1),
            receiveAvg: (sum.receive/sum.receiveCnt).toFixed(1)
        });
      }catch(e){
        console.warn(e);
      }
    }
  },
}

function _Events() {
  return {
    room_call_userConnectionDisconnected: function(e) {
      this.$delete(this.users, e.data.userId);
      this.setSummary();
    },
    room_user_leave: function(e) {
      this.$delete(this.users, e.data.userId);
      this.setSummary();
    },
    stopUserConnectionStats: function(e){
      this.$delete(this.users, e.data.userId);
      this.setSummary();
    },
    userConnectionStats: function(e){
      let {roomUser} = e.data;
      if(!roomUser.conn || !roomUser.conn || roomUser.conn.isClosed()){
        this.$delete(this.users, roomUser.userId);
        return;
      }

      const pc = roomUser.conn.getPeerConnection();

      let result = this.users[roomUser.userId];
      let existed = !!result;
      if(!existed){
        result = {userId: roomUser.userId};
      }

      Object.assign(result, _.cloneDeep(e.data.result));

      result.nickname = (roomUser.nickname || roomUser.userId) + ((!roomUser.conn.isUnifiedPlan() ? '[plan-b]' : ''));

      if(roomUser.deviceType){
        // let dt = ''
        // if(roomUser.deviceType.startsWith('Personal computer')){
        //   dt = 'PC-Bws';
        // }else if(roomUser.deviceType.startsWith('mobile - browser')){
        //   dt = 'Mobile-Bws';
        // }
        // result.device = dt + (roomUser.deviceModel ? ', ' + roomUser.deviceModel : '');
        result.device = (roomUser.deviceModel ? roomUser.deviceModel : '');
        result.version = roomUser.deviceInfo + '/' + roomUser.osInfo;
      }

      let interval = result.intervalMs / 1000;

      result.networkType = roomUser.networkType;

      {
        let connectedTime = roomUser.conn.connectedTime || pc._connectedTime;
        if(connectedTime){
          let connectTime = Date.now() - connectedTime
              ,mm = '' + parseInt(connectTime / 60000)
              ,ss = '' + parseInt(connectTime % 60000 / 1000);
          if(ss.length==1){
            ss = '0' + ss;
          }
          result.connTime = mm + 'm' + ss + 's';
        }else{
          result.connTime = 'none';
        }
      }

      // packet
      {
        let packetSent = result.video.send.bytesSent + result.audio.send.bytesSent
            ,packetReceived = result.video.receive.bytesReceived + result.audio.receive.bytesReceived;

        result.totalPacket = this.fixedN(packetSent + packetReceived);

        result.packetSent = this.fixedN(packetSent);
        result.videoBytesSent = this.fixedN(result.video.send.bytesSent);
        result.audioBytesSent = this.fixedN(result.audio.send.bytesSent);

        result.packetReceived = this.fixedN(packetReceived);
        result.videoBytesReceived = this.fixedN(result.video.receive.bytesReceived);
        result.audioBytesReceived = this.fixedN(result.audio.receive.bytesReceived);

      }

      // video streams
      (() => {
        let str = 'Video: S:';
        result.video.send.streams.forEach(function(data, i){
          if(i>0) str += ', ';
          if(data.width !== undefined && data.width !== null){
            if(data.width == 0 || data.height == 0){
              str += '<span class="warn">'+data.width+'x'+data.height+'</span>';
            }else{
              str += `${data.width}x${data.height}(${data.frameRate})`;
            }
          }
          if(result.video.send.streams.length > 1 && data.availableBandwidthKbps){
            str += `(${parseInt(data.availableBandwidthKbps/interval)})`;
          }

          let sender = pc.getSenders().find(s => (s.track && s.track.id) === data.trackId)
          if(sender && sender.track) {
            let track = sender.track;
            if(track.muted){
              str += '<span class="warn">[muted]</span>';
            }
            if(track.readyState !== 'live'){
              str += '<span class="warn">['+track.readyState+']</span>';
            }
          }
        });
        str += ' R:';
        result.video.receive.streams.forEach(function(data, i){
          if(i>0) str += ', ';
          if(data.width == 0 || data.height == 0){
            str += '<span class="warn">'+data.width+'x'+data.height+'</span>';
          }else{
            str += `${data.width}x${data.height}(${data.frameRate}, ${data.instantFramesDecoded||'-'})`;
          }
          if(result.video.receive.streams.length > 1 && data.availableBandwidthKbps){
            str += `(${parseInt(data.availableBandwidthKbps/interval)})`;
          }

          let recv = pc.getReceivers().find(s => (s.track && s.track.id) === data.trackId)
          if(recv && recv.track) {
            let track = recv.track;
            if(track.muted){
              str += '<span class="warn">[muted]</span>';
            }
            if(track.readyState !== 'live'){
              str += '<span class="warn">['+track.readyState+']</span>';
            }
          }
        });

        result.videoSizeInfo = str;
      })();

      // // frame
      // (function(){
      //   let str = 'FrameRate: S:';
      //   result.video.send.streams.forEach(function(data, i){
      //     if(i>0) str += ', ';
      //     str += data.frameRate;
      //   });
      //   str += ' R:';
      //   result.video.receive.streams.forEach(function(data, i){
      //     if(i>0) str += ', ';
      //     str += data.frameRate;
      //   });
      //
      //   result.videoFrameInfo = str;
      // })();

      result.sendPacketLostInfo = (result.video.send.instantPacketsLost||0)+'/'+(result.audio.send.instantPacketsLost||0)
          + ' (' + result.video.send.packetsLost+'/'+result.audio.send.packetsLost + ') '
          + (result.video.send.instantPacketsLost/result.video.send.instantPacketsSent*100).toFixed(1) + '%'
          + ' / '
          + (result.audio.send.instantPacketsLost/result.audio.send.instantPacketsSent*100).toFixed(1) + '%'

      result.receivePacketLostInfo = (result.video.receive.instantPacketsLost||0)+'/'+(result.audio.receive.instantPacketsLost||0)
          + ' (' + result.video.receive.packetsLost+'/'+result.audio.receive.packetsLost + ') '
          + (result.video.receive.instantPacketsLost/result.video.receive.instantPacketsReceived*100).toFixed(1) + '%'
          + ' / '
          + (result.audio.receive.instantPacketsReceived <= 0
                  ? 0
                  : (result.audio.receive.instantPacketsLost/result.audio.receive.instantPacketsReceived*100).toFixed(1)
          ) + '%';

      result.jitterBufferInfo = 'C:'+(result.video.send.captureJitterMs||0)
          + ', R:' + (result.video.receive.jitterBufferMs > 100 ? '<span class="warn">' : '<span>')
          + result.video.receive.jitterBufferMs
          + '</span>';

      result.bandwidthSetInfo = ' S:'
          + (roomUser.conn.current.bandWidth.video.send +'/'+ roomUser.conn.current.bandWidth.audio.send)
          + 'Kbps, R:'
          + (roomUser.conn.current.bandWidth.video.receive +'/'+ roomUser.conn.current.bandWidth.audio.receive)
          + 'Kbps';

      result.bandwidthInfo = (
              (
                  result.video.send.availableBandwidthKbps + result.audio.send.availableBandwidthKbps
                  + result.video.receive.availableBandwidthKbps + result.audio.receive.availableBandwidthKbps
              ) / interval
          ).toFixed(0)
          + 'Kbps'
          + ' (S:'
          + ( (result.video.send.availableBandwidthKbps/interval).toFixed(0) +'/'+ (result.audio.send.availableBandwidthKbps/interval).toFixed(0))
          + 'Kbps, R:'
          + ( (result.video.receive.availableBandwidthKbps/interval).toFixed(0) +'/'+ (result.audio.receive.availableBandwidthKbps/interval).toFixed(0))
          + 'Kbps)';

      // rtt
      let rtt_v = result.video.send.rtt || result.video.receive.rtt,
          rtt_a = result.audio.send.rtt || result.audio.receive.rtt;
      result.rttInfo = (rtt_v > 100 ? '<span class="warn">' : '<span>')
          + (rtt_v||'-')+'ms'
          + '</span>'
          + '/'
          + (rtt_a > 100 ? '<span class="warn">' : '<span>')
          + (rtt_a||'-')+'ms'
          + '</span>';

      if(!existed){
        this.$set(this.users, roomUser.userId, result);
      }
      this.setSummary();
    },
  }
}
// _Events.mixerConnectionStats = function(e){
//   e.data.roomUser = e.data.mixer
//   _Events.userConnectionStats.call(this, e);
// }
</script>

<style lang="scss" scoped>
.new-window {
  .conn-stats {
    display: inline-block;
    border: 1px solid #000;
    font-size: 12px;
    font-weight: 500;
    color: #000;
    pointer-events: auto !important;

    .conn-summary {
    }
    .conn-stats-user {
      padding: 2px 2px 2px 10px !important;
      margin: 0;
      background-color: #f0f0f0 !important;
      border-right: 1px solid rgb(139 139 139);
      border-bottom: 1px solid rgb(139 139 139);
      margin: 1px;
      letter-spacing: 0.1px !important;
      line-height: 4px !important;;
    }
  }
}
.conn-stats {
  //position: absolute;
  //z-index: 10;
  //top: 50px;
  //left: 0;
  color: yellow;
  font-size: 10px;
  font-weight: 100;
  display: inline-block;
  padding-top: 7px;
  background-color: #000000a3;
  word-break: break-all;
  word-wrap: break-word;
  overflow: auto;
  pointer-events: none;

  .conn-stats-user {
    display: inline-block;
    padding: 10px;
    letter-spacing: 0.5px;
    line-height: 14px;
    background-color: rgba(0,0,0,0.3);
    border-right: 1px solid rgba(255,255,255,0.2);
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }

  [class^="warn"] {
    color:red;
    font-weight:bold;
  }
}
</style>